const {loadImage} = require('./loadImageByPromise');
const { default: transform_image } = require('./transform_image');
const { SVGPointToApiData } = require('./scale_calcrulate');
const axios = require('axios');

const iframe_id = 'hacky-scrollbar-resize-listener';
const event_listener_list = [];
const createBodyResizeEvent = () => {
    return new Promise( resolve => {

        var iframe = document.createElement('iframe');
        iframe.id = iframe_id;
        iframe.style.cssText = 'height: 0; background-color: transparent; margin: 0; padding: 0; overflow: hidden; border-width: 0; position: absolute; width: 100%;';

        iframe.onload = function() {
            let evt;
            try {
                evt = new CustomEvent('body_resize');
            } catch(e) {
                evt = document.createEvent('UIEvents');
                evt.initUIEvent('body_resize', true, false, window, 0);
            }

            const dispatch_event = () => window.dispatchEvent(evt);
            iframe.contentWindow.addEventListener('resize', dispatch_event);
            resolve();
        };
        document.body.appendChild(iframe);

    })
};

// localStorageに保存するためbase64で返す
const compressImage = async (img_el, limit_size = 9999999) => {
    const resize_size = 1000;
    const canvas = drawImageToCanvas(img_el, resize_size);

    let resized_blob = await canvasToBlob(canvas,"image/jpeg");
    //寸法リサイズ後、まだファイルサイズが規定以上の場合はさらに品質も落とす
    resized_blob = (limit_size > resized_blob.size)
        ? resized_blob
        : await canvasToBlob(canvas,"image/jpeg" , limit_size / resized_blob.size);

    return new Promise(r => {
        let reader = new FileReader();
        reader.readAsDataURL(resized_blob);
        reader.onload = () => { r(reader.result) }
    });
};
const drawImageToCanvas = (img_el, resize_size) => {
    const canvas = document.createElement('canvas');

    const longer = img_el.width >= img_el.height ? img_el.width : img_el.height;
    const ratio = resize_size / longer;

    const w = Math.round(img_el.width * ratio);
    const h = Math.round(img_el.height * ratio);

    const ctx = canvas.getContext('2d');
    canvas.width = w;
    canvas.height = h;
    ctx.drawImage(img_el, 0, 0, w, h);

    return canvas;
};
const canvasToBlob = (canvas, type = 'image/jpeg', quality = 1) => {
    return new Promise(resolve => {
        canvas.toBlob( blob => resolve(blob), type, quality )
    })
};

/**
 * オブジェクトが空かどうかを判定する
 * @param obj
 * @return boolean
 */
function empty(obj) {
    return Boolean(Object.keys(obj).length);
}

async function convertCanvasToImageElement(cv) {
    const uri = cv.toDataURL('image/jpeg', 1);
    return await loadImage(uri);
}

async function getTransformedImage(img_info) {
    const params = new URLSearchParams();
    params.append('json', JSON.stringify(img_info));

    const res = await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}imagick.php`,
        params,
        {responseType: 'blob'}
    );
    const url = URL.createObjectURL(res.data);
    const image = await loadImage(url);
    URL.revokeObjectURL(url);
    return image;
}

function roundOffWithDecimalPlace(num, decimal_place) {
    const digit = Math.pow(10, decimal_place);
    let temp = num * digit;
    temp = Math.floor(temp);
    return temp / digit;
}

async function getImageConfig(data) {
    //画像張り込みに必要なデータが揃っていない場合
    if ( !(data.points && data.item_data && data.item_type && data.rect_width) ) return null;

    const calculated_data = SVGPointToApiData(Object.values(data.points));
    const transform_data = {...data, ...calculated_data}; //transform_data=img_info

    //three.jsでカーテンを生成して、glfxで画像を歪ませる。
    const image = await transform_image(transform_data);

    return {
        x:transform_data.x_offset,
        y:transform_data.y_offset,
        image,
        width: image.width,
        height: image.height,
    };
}

async function loadCsv(path) {
    const res = await axios.get(path, {responseType: 'text'});
    if ( !res.headers['content-type'].includes('text/csv') ) throw new Error('データ形式がCSVではありません');

    let [header, ...data] = csvToArray(res.data.trim());
    header = header.map(s => s.trim());
    data = data.map(d => d.reduce((obj, row, i) => {
        obj[header[i]] = row;
        return obj;
    },{}));
    return data;
}

function csvToArray(csv) {
    const arr = csv
        .split('\n')
        .map(s => s
            .split(',')
            .map(d => canConvertNumber(d) ? parseFloat(d) : d)
        );
    return arr;
}

function canConvertNumber(x) {
    if( typeof(x) != 'number' && typeof(x) != 'string' )
        return false;
    else
        return !!(x == parseFloat(x) && isFinite(x));
}

const checkLocalStorageAvailable = () => {
    var type = 'localStorage';
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch(e) {
        return e instanceof DOMException && (
                // everything except Firefox
            e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            // acknowledge QuotaExceededError only if there's something already stored
            (storage && storage.length !== 0);
    }
};

async function getPredictImage(base64img) {
    const params = new URLSearchParams();
    params.append('base64img', base64img);

    const res = await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}predict.php`,
        params,
        {responseType: 'text'}
    );

    return res.data;
}

function calculatePoint(points) {
    const pt = points.map(p => p.map( (n) => n / 100) );
    const {w, h} = {w: 1000, h: 1000};
    // const {w, h} = this.konva_stage ?
    //     {w: this.konva_stage.width(), h: this.konva_stage.height()} :
    //     {w: 1000, h: 1000} ;

    return {
        top_left:     {x: w * pt[0][0], y: h * pt[0][1]},
        top_right:    {x: w * pt[1][0], y: h * pt[1][1]},
        bottom_left:  {x: w * pt[2][0], y: h * pt[2][1]},
        bottom_right: {x: w * pt[3][0], y: h * pt[3][1]},
    }
}

module.exports = {
    getWidthWithoutPadding(el) {
        const horizontal_padding = el.style.paddingRight + el.style.paddingLeft;
        return el.clientWidth - horizontal_padding;
    },
    async addBodyResizeEventLister(callback) {
        if ( !document.getElementById(iframe_id) ) await createBodyResizeEvent();
        event_listener_list.push(callback);
        window.addEventListener('body_resize', callback);
    },
    removeAllEventListeners() {
        event_listener_list.forEach(e => window.removeEventListener('body_resize',e));
        event_listener_list.length = 0; //配列を空に
    },
    compressImage,
    empty,
    convertCanvasToImageElement,
    getTransformedImage,
    roundOffWithDecimalPlace,
    getImageConfig,
    loadCsv,
    checkLocalStorageAvailable,
    getPredictImage,
    calculatePoint,
};


